import React, { useState, useEffect } from "react";
import "./style.scss";
import logo from "../../Assets/Images/logo.png";
import arrowDown from "../../Assets/Images/open-button.png";
import { Link } from "react-router-dom";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

function Header() {
    const { t } = useTranslation();

    const langMap = React.useMemo<Record<string, string>>(
        () => ({
            ja: "JPN",
            en: "ENG",
        }),
        []
    );

    const getInitialLang = () => {
        return langMap[i18next.language] || "JPN";
    };

    const [lang, setLang] = useState(getInitialLang);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        const handleLangChange = (lng: string) => {
            setLang(langMap[lng] || "JPN");
        };

        i18next.on("languageChanged", handleLangChange);

        return () => {
            i18next.off("languageChanged", handleLangChange);
        };
    }, [langMap]);

    const handleChangeLang = (lng: string, label: string) => {
        i18next.changeLanguage(lng); 
        setOpenDropdown(false);
    };

    const dataMenu = [
        { key: "home", router: "/" },
        { key: "about", router: "/about" },
        { key: "spaceDesign", router: "/spacedesign" },
        { key: "installedGallery", router: "/installedgallery" },
        { key: "newsletter", router: "/newsletter" },
        { key: "contact", router: "/contact" },
    ];
    return (
        <>
            <header>
                {/* //logo  */}
                <div className="header-logo">
                    <div className="logo">
                        <Link to="/">
                            <img src={logo} alt="" />
                        </Link>
                    </div>

                    <div className="right-items">
                        <div onClick={() => setOpenDropdown(!openDropdown)} className="lang">
                            <span>{lang}</span>
                            <img src={arrowDown} alt="" />
                            {openDropdown && (
                                <ul className="list-lang">
                                    <li onClick={() => handleChangeLang("ja", "JPN")}>JPN</li>
                                    <li onClick={() => handleChangeLang("en", "ENG")}>ENG</li>
                                </ul>
                            )}
                        </div>

                        <div className="menu-mobile">
                            <div onClick={() => setShowMenu(!showMenu)} className="mobile-icon">
                                <div className={"nav-toggle" + (showMenu ? " open" : "")}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* /menu */}
                <ul className="menu">
                    {dataMenu.map((item, index) => (
                        <li key={index} className="menu-items">
                            <Link to={item.router}>{t(`menu.${item.key}`)}</Link>
                        </li>
                    ))}
                </ul>
            </header>

            <aside className={`list-menu-mobile ${showMenu ? "openMenu" : "closeMenu"}`}>
                {/* <div onClick={() => setShowMenu(false)} className="icon-close">
                    <p>X</p>
                </div> */}
                <ul className="menu-mobile-list">
                    {dataMenu.map((item, index) => (
                        <li key={index} className="menu-mobile-items">
                            <Link
                                to={item.router}
                                onClick={() => {
                                    setShowMenu(!showMenu);
                                }}
                            >
                                {t(`menu.${item.key}`)}
                            </Link>
                        </li>
                    ))}
                </ul>
            </aside>
        </>
    );
}

export default Header;
